
import createphonenumber from '../assets/codewars/codewars-6kyu-Create-Phone-Number.png'
import findtheodd from '../assets/codewars/codewars-6kyu-Find-the-odd-int.png'
import equalsidesofanarray from '../assets/codewars/codewars-6kyu-Equal-Sides-Of-An-Array.png'
import uniqueInOrder from '../assets/codewars/codewars-6kyu-Unique-In-Order.png'

export const codewarsdata=[
    {
        id:1,
        name:"Create Phone Number",
        image:createphonenumber,
        github:"https://github.com/AnilBASARAN/codewars-6kyu-Create-Phone-Number",
        live:"https://github.com/AnilBASARAN/codewars-6kyu-Create-Phone-Number/blob/main/codewars-6kyu-Create-Phone-Number.png",
    },
    {
        id:2,
        name:"Find the Odd",
        image:findtheodd,
        github:"https://github.com/AnilBASARAN/codewars-6kyu-Find-the-odd-int",
        live:"https://github.com/AnilBASARAN/codewars-6kyu-Find-the-odd-int/blob/main/codewars-6kyu-Find-the-odd-int.png",
    },
    {
        id:3,
        name:"Equal Side of an Array",
        image:equalsidesofanarray,
        github:"https://github.com/AnilBASARAN/codewars-6kyu-Equal-Sides-Of-An-Array",
        live:"https://github.com/AnilBASARAN/codewars-6kyu-Equal-Sides-Of-An-Array/blob/main/codewars-6kyu-Equal-Sides-Of-An-Array.png",
    },
    {
        id:4,
        name:"Unique in Order",
        image:uniqueInOrder,
        github:"https://github.com/AnilBASARAN/codewars-6kyu-Unique-In-Order",
        live:"https://github.com/AnilBASARAN/codewars-6kyu-Unique-In-Order/blob/main/codewars-6kyu-Unique-In-Order.png",
    },


]